export type GradientsType = {
	[key: string]: string
}

export const gradients: GradientsType = {
	breakfast: 'linear-gradient(90deg, #30CFD0cc 0%, #330867cc 100%)',
	terrify: 'linear-gradient(90deg, #6A85B6cc 0%, #BAC8E0cc 100%)',
	foreigner:
		'linear-gradient(90deg, #3F51B1cc 0%, #5A55AEcc 13%, #7B5FACcc 25%, #8F6AAEcc 38%, #A86AA4cc 50%, #CC6B8Ecc 62%, #F18271cc 75%, #F3A469cc 87%, #F7C978cc 100%)',
	silver: 'linear-gradient(90deg, #3D4E81cc 0%, #5753C9cc 48%, #6E7FF3cc 100%)',
	city: 'linear-gradient(90deg, #FF057Ccc 0%, #7C64D5cc 48%, #4CC3FFcc 100%)',
	modest: 'linear-gradient(90deg, #473B7Bcc 0%, #3584A7cc 51%, #30D2BEcc 100%)',
	snake: 'linear-gradient(90deg, #B7F8DBcc 0%, #50A7C2cc 100%)',
	agent: 'linear-gradient(90deg, #CBBACCcc 0%, #2580B3cc 100%)',
	glow: 'linear-gradient(90deg, #EC77ABcc 0%, #7873F5cc 100%)',
	fox: 'linear-gradient(90deg, #D7D2CCcc 0%, #304352cc 100%)',
	professor: 'linear-gradient(90deg, #616161cc 0%, #9BC5C3cc 100%)',
	trait:
		'linear-gradient(90deg, #3D3393cc 0%, #2B76B9cc 37%, #2CACD1cc 65%, #35EB93cc 100%)',
	whatever: 'linear-gradient(90deg, #0ACFFEcc 0%, #495AFFcc 100%)',
	decide: 'linear-gradient(90deg, #243949cc 0%, #517FA4cc 100%)',
	area: 'linear-gradient(90deg, #1E3C72cc 0%, #1E3C72cc 1%, #2A5298cc 100%)',
}
